import React, { FC, useState, useEffect, useContext } from 'react'
import platform from 'platform'
import { notify } from 'react-notify-toast'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import {
  getUserData,
  checkUserSubscriptionStatus,
  deleteUser,
} from '../../../../Api/backendApi'

import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../../GenericComponents/GenericCloseButton'

import {
  SingleSettingModalBox,
  UserDataContainer,
} from '../../style/UserProfileStyle'

interface RemoveAccountInterface {
  closeModal: Function
}

const RemoveAccount: FC<RemoveAccountInterface> = ({ closeModal }) => {
  const [userData, setUserData] = useState(Object)

  const getUser = async () => {
    const result: any = await getUserData()

    setUserData(result)
  }

  useEffect(() => {
    ;(async () => {
      getUser()
    })()
  }, [])

  return (
    <SingleSettingModalBox>
      <GenericCloseButton onClick={closeModal} />
      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          Usuń konto
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          fSize={'1.4rem'}
          margin={'3% 0 0 0'}
          fWeight={'bold'}
          width={isMobile ? '90%' : '60%'}
        >
          Czy na pewno chcesz usunąć konto z aplikacji Miazga by FMW? Operacja
          ta jest nieodwracalna.
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericButton
          width={'40%'}
          className="danger"
          margin={'4% auto'}
          justify={'center'}
          onClick={() => deleteUser()}
        >
          Usuń konto
        </GenericButton>
        <GenericButton
          width={'40%'}
          className="standard"
          margin={'4% auto'}
          justify={'center'}
          onClick={() => closeModal()}
        >
          Anuluj
        </GenericButton>
      </GenericRow>
    </SingleSettingModalBox>
  )
}

export default RemoveAccount
